var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurposeOfPayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.212 15.637L4.5 16.167L5.03 12.455L14.576 2.90901C14.998 2.48705 15.5703 2.25 16.167 2.25C16.7637 2.25 17.336 2.48705 17.758 2.90901C18.18 3.33097 18.417 3.90327 18.417 4.50001C18.417 5.09675 18.18 5.66905 17.758 6.09101L8.212 15.637Z",
    stroke: "#8F27C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25H2.25C1.85218 8.25 1.47064 8.40804 1.18934 8.68934C0.908035 8.97064 0.75 9.35218 0.75 9.75V20.25C0.75 20.6478 0.908035 21.0294 1.18934 21.3107C1.47064 21.592 1.85218 21.75 2.25 21.75H21.75C22.1478 21.75 22.5294 21.592 22.8107 21.3107C23.092 21.0294 23.25 20.6478 23.25 20.25V9.75C23.25 9.35218 23.092 8.97064 22.8107 8.68934C22.5294 8.40804 22.1478 8.25 21.75 8.25H20.25M20.25 18H12.75M20.25 14.25H15.75",
    stroke: "#8F27C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurposeOfPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purpose-of-payment.118c07dae6d1402fab258c8b3bf39781.svg";